import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getCookie } from 'helpers';

const uislice = createSlice({
    name: 'uislice',
    initialState: {
        isNavigationItemHover: false,
        isCookieAgree: getCookie('cookieIsAgree') || false,
    },
    reducers: {
        setNavigationItemHover: (state, action) => {
            state.isNavigationItemHover = action.payload;
        },
        setAgreeCookie: state => {
            document.cookie = 'cookieIsAgree=true';
            state.isCookieAgree = true;
        },
    },
});

export const selectIsNavigationItemHover = createSelector([state => state.ui], data => data.isNavigationItemHover);

export const selectIsCookieAgree = createSelector([state => state.ui], data => data.isCookieAgree);

export const { setNavigationItemHover, setAgreeCookie } = uislice.actions;

export default uislice.reducer;
